<template>
  <tabBar :idIndex="4"></tabBar>
  <div class="main">
    <div class="box1">
      <div class="title"> {{$t("peopleAndValue.people")}}</div>
      <div class="text">
       {{$t("peopleAndValue.content")}}
      </div>

    </div>
    <div class="box2">
      <div class="boxImg1">
        <img style="border-radius: 4px" src="@/assets/homeImg/pepon1.png">
      </div>
      <div class="boxImg2">
        <img style="border-radius: 4px" src="@/assets/homeImg/pepon2.png">

      </div>

    </div>
  </div>


  <bottom></bottom>
</template>
<script setup>
import tabBar from '@/components/tabBar/tabIndex.vue'
import Bottom from '@/components/bottom/footNavigation.vue'

//   const toDetail = () => {
//     console.log('kkkkkkk')
//   }
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100vh;
  background: url("@/assets/homeImg/offer.png") no-repeat;
  background-size: cover;
  overflow-x: hidden;
  position: relative;

  .active {
    color: #00A2EA;
    font-size: 24px;
  }

  .box1 {
    position: absolute;
    width: 359px;
    height: 408px;
    top: 306px;
    left: 260px;

    .title {
      width: 354px;
      font-size: 50px;
      font-weight: normal;
      color: #FFFFFF;
      white-space: nowrap;
      margin-bottom: 51px;

    }

    .text {
      width: 359px;
      height: 241px;
      font-size: 16Px;
      font-weight: normal;
      color: #FFFFFF;
      text-indent: 32px;
      line-height: 32Px;
      text-align: justify;
      word-wrap: break-word;
      word-break: break-all;
    }

    .button {
      display: flex;
      height: 55px;
      width: 100%;
      align-items: center;

      .page {
        color: #FFFFFF;
        font-size: 18px;
        margin: 0 28px;
      }

      .bt {
        width: 51px;
        height: 51px;
        border: 1px solid #FFFFFF;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

.box2 {
  height: 424px;
  width: 988px;
  position: absolute;
  top: 380px;
  left: 673px;
  display: flex;
  justify-content: flex-end;

  .boxImg1 {
    width: 558px;
    height: 364px;
    border-radius: 4px;
    margin-right: 35px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .boxImg2 {
    width: 261px;
    height: 364px;
    border-radius: 4px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bgcBlue {
    width: 279px;
    height: 280px;
    border-radius: 10px;
    background: url("@/assets/homeImg/bule.7.png");
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 25px 0 49px;

    .Blue_head {
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: space-between;
      margin-top: 44px;
      align-items: center;

      img {
        width: 70px;
        height: 70px;
      }

      .text {
        font-size: 50px;
        font-weight: normal;
        color: #FFFFFF;
        opacity: 0.67;
      }


    }

    .title {
      font-size: 24px;
      font-weight: normal;
      color: #FFFFFF;
      margin-top: 32px;

    }

    .introduce {
      width: 214px;
      height: 45px;
      font-size: 17px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #FFFFFF;
      margin-top: 17px;
      text-indent: 32px;
      text-align: end;
      line-height: 20px;
    }
  }
}
</style>
